import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Lightbox from 'react-images'

export class Content extends Component {

  state = {
    content: this.props.content,
    images: [],
    currentImage: 0,
    lightboxOpen: false
  }

  componentDidMount() {
    this.setState(() => ({
      content: this.getContent(),
    }), () => {
      const images = [...document.getElementById('html-content').querySelectorAll('img')]
      images.forEach(image => image.addEventListener('click', () => this.showLightbox(image)))
      this.setState({
        images
      })
    })
  }

  closeLightbox = () => this.setState({ lightboxOpen: false })

  showLightbox = image => {
    const currentImageIndex = this.state.images
      .map(img => img.getAttribute('src'))
      .findIndex(imgSrc => imgSrc === image.getAttribute('src'))

    if (currentImageIndex !== -1) {
      this.setState({
        currentImage: currentImageIndex,
        lightboxOpen: true
      })
    }
  }

  componentWillUnmount() {
    this.state.images.forEach(image => image.removeEventListener('click', () => this.showLightbox(image)))
  }

  getContent = () => {
    const { article } = this.props
    let content = article.content

    // replace relative image paths in article
    if (article.resources) {
      Object.entries(article.resources).forEach(([relativePath, url]) => {
        content = content.replace(relativePath, url)
      })
    }

    return content
  }

  next = () => {
    if ((this.state.currentImage + 1) < this.state.images.length) {
      this.setState({currentImage: this.state.currentImage + 1})
    }
  }

  prev = () => {
    if ((this.state.currentImage - 1) >= 0) {
      this.setState({currentImage: this.state.currentImage - 1})
    }
  }

  render() {
    return (
      <Fragment>
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.state.images.map(img => ({ src: img.getAttribute('src') }))}
          isOpen={this.state.lightboxOpen}
          onClose={this.closeLightbox}
          onClickPrev={this.prev}
          onClickNext={this.next}
          showImageCount={false}
          backdropClosesModal={true}
        />
        <ContentWrapper id="html-content" dangerouslySetInnerHTML={{ __html: this.getContent() }}/>
      </Fragment>
    )
  }
}

const ContentWrapper = styled.div`
  // to avoid breaking layout on mobile devices when large image / table is in html content
  p {
    overflow: auto;
  }
  
  table {
    width: 100%;
  }
`
